// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playerFormErrorTips{color:red;text-align:right;margin-right:30px}", ""]);
// Exports
module.exports = exports;
